const baseUrl = 'https://res.cloudinary.com/kendra-scott/image/upload/' // Hardcode the base URL here (lets not move this to .env because it'll not change).
export const getUrl = (assetUrl) => {
    return baseUrl + assetUrl
}
